module.exports = __webpack_public_path__ + "img/icon_full_pt.ac08d47a.png";